module.exports = __webpack_public_path__ + "static/media/brandCom.631d0813.png";